<template>
  <div class="mapcontainer">
    <b-row class="justify-content-center">
      <b-col lg="8">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Adresse"
              v-model="searchString"
              @keyup.enter="centerMapToAddress"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" @click="centerMapToAddress"
                >Suchen <i class="fa fa-search"></i
              ></b-button>
            </b-input-group-append>
          </b-input-group>
          <span id="mapsearchsubtitle" v-show="showSubtitle">{{
            subtitle
          }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <l-map :zoom="zoom" :center="center" ref="mimamap">
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <l-marker
        v-for="(marker, index) in getAvailableFacilityCoordinates"
        :key="'available_' + index"
        :lat-lng="marker"
        :icon="availableFacilityIcon"
      >
        <l-popup :content="getMapAvailableFacilityPopupInfos(index)"></l-popup>
      </l-marker>
      <l-marker
        v-for="(marker, index) in getAssignedFacilityCoordinates"
        :key="'assigned' + index"
        :lat-lng="marker"
        :icon="assignedFacilitiesIcon"
      >
        <l-popup :content="getMapAssignedFacilityPopupInfos(index)"></l-popup>
      </l-marker>
    </l-map>
  </div>
</template>
<script>
// Leaflet, OpenStreetMaps
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import { mapGetters } from "vuex";
import { nominatim } from "../../store/nominatim";

export default {
  computed: {
    ...mapGetters([
      "getFacilityCoordinates",
      "getFacilityPopupInfos",
      "getMapAvailableFacilities",
      "getMapFacilities",
      "getMapAssignedFacilities",
      "getMapAssignedFacilityPopupInfos",
      "getMapAvailableFacilityPopupInfos",
    ]),
    getAvailableFacilityCoordinates() {
      return this.getMapAvailableFacilities.map((facility) => {
        return L.latLng(facility.Latitude, facility.Longitude);
      });
    },
    getAssignedFacilityCoordinates() {
      return this.getMapAssignedFacilities.map((facility) => {
        return L.latLng(facility.Latitude, facility.Longitude);
      });
    },
  },
  data() {
    return {
      zoom: 13,
      // center map to Innsbruck, Tyrol, Austria
      center: L.latLng(47.259659, 11.400375),
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      subtitle:
        "Adresse konnte nicht gefunden werden. Überprüfen Sie Ihre Eingabe und geben Sie ebenfalls die Postleitzahl, den Ort und das Land an.",
      showSubtitle: false,
      searchString: "",
      availableFacilityIcon: L.icon({
        iconUrl: require("../../public/map-marker-blue.png"),
        iconSize: [64, 64],
        popupAnchor: [0, -20],
      }),
      assignedFacilitiesIcon: L.icon({
        iconUrl: require("../../public/map-marker-red.png"),
        iconSize: [64, 64],
        popupAnchor: [0, -20],
      }),
    };
  },
  methods: {
    centerMapToAddress() {
      this.showSubtitle = false;
      nominatim.queryNominatimGeoCoordinates(this.searchString, (response) => {
        if (response.data.length === 0) {
          this.showSubtitle = true;
          return;
        }
        this.center = L.latLng(
          response.data[0]["lat"],
          response.data[0]["lon"]
        );
      });
    },
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
};
</script>

<style scoped>
.mapcontainer {
  height: 60vh;
  text-align: center;
  margin-bottom: 5vh;
}

#mapsearchsubtitle {
  color: red;
}

.red {
  color: red;
}
</style>
